import React, { Component } from "react";
import classNames from "classnames";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import * as focusedSectionActions from "./actions/focusedSectionAction";

// @ts-ignore
const SectionFocusedContext = React.createContext({
  isSectionFocused: false,
  setSectionFocus: () => {},
  focusedBorder: "",
});

export interface SectionFocusedContextValue {
  isSectionFocused: boolean;
  setSectionFocus: (isFocused: boolean) => void;
  focusedBorder: string;
  sectionId?: string;
}

const styles = (theme: Theme) =>
  createStyles({
    focusedBorder: {
      border: "1px solid !important",
      borderColor: "#1D7DEA !important",
      backgroundColor: "#FAFCFF",
    },
    transparentBorder: {
      border: "1px solid transparent",
    }
  });

interface Props extends WithStyles<typeof styles> {
  initiallyActive?: boolean;
  sectionId?: string;
  focusSection: (sectionId: string) => void;
  applyFocusedBorder?: boolean;
  onFocusChange?: (isFocused: boolean, sectionId?: string) => void;
  autoSave:Function,
  currentlyFocusedSection:string
}

interface State extends SectionFocusedContextValue {}

class MyPATBaseSection extends Component<Props, State> {
  setSectionFocus = (isFocused: boolean, newSectionId?: string) => {
    const { sectionId, focusSection, onFocusChange } = this.props;
    this.setState(
      {
        isSectionFocused: isFocused,
      },
      () => {
        if (newSectionId) {
          focusSection(newSectionId);
        } else if (sectionId) {
          focusSection(sectionId);
        }

        if (onFocusChange) {
          onFocusChange(isFocused, sectionId);
        }
      }
    );
  };

  state: State = {
    isSectionFocused: this.props.initiallyActive || false,
    setSectionFocus: this.setSectionFocus,
    focusedBorder: this.props.classes.focusedBorder,
    sectionId: this.props.sectionId,
  };
  componentDidUpdate(prevProps:Props,prevState:State){
    if(prevState.isSectionFocused&&!this.state.isSectionFocused && this.props.autoSave){
      this.props.autoSave();
    }
  }
  render() {
    const { isSectionFocused } = this.state;
    const { classes, sectionId, applyFocusedBorder = true } = this.props;
    return React.Children.map(this.props.children, (child: any) => {
      if (!React.isValidElement(child)) {
        return <></>;
      }
      // @ts-ignore
      const { className } = child.props;
      const newClassNames = classNames(
        className,
        applyFocusedBorder && classes.transparentBorder,
        isSectionFocused && applyFocusedBorder && classes.focusedBorder
      );

      return (
        <SectionFocusedContext.Provider value={this.state}>
          {React.cloneElement(child as any, {
            className: newClassNames,
            id: sectionId,
          })}
        </SectionFocusedContext.Provider>
      );
    });
  }
}

export { SectionFocusedContext };

const mapDispatchToProps = {
  focusSection: focusedSectionActions.focusSection,
};
const mapStateToProps = (state: any) => {
  return {
    // currentlyFocusedSection: state.commonData.focusedSection.currentlyFocusedSection,
  }
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MyPATBaseSection)
);
